import { toast } from '@design-system/components/atoms'
import type React from 'react'
import { TOAST_STR } from 'src/constant'
import type { CommonError } from 'src/dto'

import { isCaptchaError } from '../axios/maxios/captchaGate'
import { envUtils } from '../envUtils'

type ToastMessage = string | (() => string)

const resolveMessage = (msg: ToastMessage): string => (typeof msg === 'function' ? msg() : msg)

export const toastSuccess = (text: ToastMessage, actionButton?: React.ReactNode) => {
  return toast.success(resolveMessage(text), actionButton)
}

export const toastNotice = (text: ToastMessage) => {
  return toast.info(resolveMessage(text))
}

export const toastError = (text: ToastMessage, actionButton?: React.ReactNode) => {
  return toast.error(resolveMessage(text), actionButton)
}

export const toastFailure = (text: ToastMessage, actionButton?: React.ReactNode) => {
  return toast.failure(resolveMessage(text), actionButton)
}

export const toastDelete = (text: ToastMessage) => {
  return toast.delete(resolveMessage(text))
}

// Error Code가 400번대이면 백엔드 메세지, 500번대이면 TOAST_STR.errorMessage, 400이면 toastError 띄우지 않고, response 리턴해서 화면에서 처리한다.
export const commonErrorMessage = (error?: CommonError) => {
  // catch 블록에서 axios 인터셉터를 거치지 않은 값이 넘어오면 인자가 비어 있다.
  if (!error) return

  // 응답 없는 실패의 message 는 axios 원문("timeout exceeded" 등)이라 사용자에게 노출하지 않는다.
  if (error.type === 'network') {
    toastError(TOAST_STR.errorMessage)
  }

  if (error.message === 'canceled') return

  // Datadog RUM 은 console.error 를 에러 이벤트로 수집하므로, 토스트조차 띄우지 않는 정상 비즈니스
  // 응답(400 등)까지 Error Tracking 에 올라간다. env 를 못 읽어도 프로덕션이 아닌 쪽으로 떨어져
  // 로그만 남고 수집은 되지 않는다.
  if (!envUtils.isLive) {
    console.error(error)
  }

  if (error.type === 'API') {
    const code = Number(error.status)
    if (code > 400 && code < 500) {
      // 캡차 요구·차단은 maxios 인터셉터가 모달·공용 안내로 이미 처리했다
      if (!isCaptchaError(error)) toastError(error.message)
    } else if (code >= 500) {
      toastError(TOAST_STR.errorMessage)
    }
  }

  if (error.type === 'client' && !error.disableToast) {
    toastError(error.message ?? TOAST_STR.errorMessage)
  }

  return error
}
